import classNames from 'classnames';
import React from 'react';

import Loader from '@/components/loading';

import type ButtonTypes from './ButtonTypes';

const Button: React.FC<ButtonTypes> = ({
  loading = false,
  children,
  classes,
  buttonType = 'primary',
  ...props
}: ButtonTypes) => {
  const commonClasses =
    'inline-flex items-center justify-center rounded-md px-4 py-2 gap-2 font-medium text-sm border border-primary transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed';

  const dynamicClasses = {
    'bg-brand text-white hover:bg-brand-600': buttonType === 'primary',
    'bg-transparent text-primary hover:border-brand-600 hover:text-brand-600':
      buttonType !== 'primary',
  };

  const combinedClasses = classNames(commonClasses, dynamicClasses);
  return (
    <button
      className={`${combinedClasses} ${classes}`}
      disabled={loading}
      {...props}
    >
      {children}
      {loading && <Loader />}
    </button>
  );
};

export default Button;
